import React, { useEffect, useRef, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import ForceGraph2D from "react-force-graph-2d";
import { DataLabel } from "../components/common";
import { ShareNetwork } from "@phosphor-icons/react";

const UNI_COLORS = {
  "salud-piel": "#0B3B2D", "medicina-estetica": "#2563EB", "medicina-general": "#166534",
  "salud-capilar": "#D95D39", "medicina-longevidad": "#7c3aed", "salud-sexual": "#be185d",
  "cosmetica-personalizada": "#0891b2",
};

export default function LinkingGraph() {
  const [data, setData] = useState({ nodes: [], links: [] });
  const wrapRef = useRef(null);
  const [dim, setDim] = useState({ w: 800, h: 520 });

  const load = () => api.get("/graph").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);
  useEffect(() => {
    const ro = () => { if (wrapRef.current) setDim({ w: wrapRef.current.clientWidth, h: 520 }); };
    ro(); window.addEventListener("resize", ro); return () => window.removeEventListener("resize", ro);
  }, [data.nodes.length]);

  const recompute = async () => { await api.post("/agents/internal_linking/run"); toast.success("Maillage recalculé"); setTimeout(load, 3000); };

  return (
    <div>
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="text-[11px] font-mono uppercase tracking-[0.25em] text-muted-foreground mb-1">Topologie du contenu</div>
          <h1 className="font-serif text-4xl text-brand tracking-tight">Maillage interne</h1>
        </div>
        <button data-testid="recompute-links-btn" onClick={recompute}
          className="flex items-center gap-2 border border-brand text-brand hover:bg-brand-soft px-4 py-2 rounded-md text-sm font-medium transition-colors">
          <ShareNetwork size={16} /> Recalculer le maillage
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        <div ref={wrapRef} className="lg:col-span-3 bg-white border border-border rounded-md overflow-hidden" style={{ height: 520 }}>
          {data.nodes.length === 0 ? (
            <div className="h-full flex flex-col items-center justify-center text-muted-foreground">
              <ShareNetwork size={32} className="mb-2" />
              <p className="text-sm">Publiez des contenus pour visualiser le graphe de maillage.</p>
            </div>
          ) : (
            <ForceGraph2D width={dim.w} height={dim.h} graphData={data}
              backgroundColor="#FFFFFF" linkColor={() => "#D8DCD5"} linkWidth={(l) => Math.min(3, (l.value || 1))}
              nodeRelSize={5}
              nodeCanvasObject={(node, ctx, scale) => {
                const label = (node.name || "").slice(0, 22);
                ctx.beginPath();
                ctx.arc(node.x, node.y, 5, 0, 2 * Math.PI);
                ctx.fillStyle = UNI_COLORS[node.universe] || "#0B3B2D";
                ctx.fill();
                ctx.font = `${11 / scale}px "IBM Plex Sans"`;
                ctx.fillStyle = "#57606A";
                ctx.fillText(label, node.x + 7, node.y + 3);
              }} />
          )}
        </div>

        <div className="space-y-4">
          <div className="bg-white border border-border rounded-md p-5">
            <DataLabel>Statistiques</DataLabel>
            <div className="mt-3 space-y-2 text-sm">
              <div className="flex justify-between"><span className="text-muted-foreground">Nœuds</span><span className="font-mono">{data.nodes.length}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Liens</span><span className="font-mono">{data.links.length}</span></div>
            </div>
          </div>
          <div className="bg-white border border-border rounded-md p-5">
            <DataLabel>Univers</DataLabel>
            <div className="mt-3 space-y-1.5">
              {Object.entries(UNI_COLORS).map(([k, c]) => (
                <div key={k} className="flex items-center gap-2 text-xs">
                  <span className="w-2.5 h-2.5 rounded-full" style={{ background: c }} /><span className="text-muted-foreground">{k}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
